var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unskippedAutomations.length > 0)?_c('AutomationResultConfirmModal',{attrs:{"visible":_vm.showUnskippedResultConfirmModal,"automations":_vm.unskippedAutomations},on:{"close":_vm.onClose,"skipped":_vm.saveSkippedAutomations}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }